import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import authDirective from './directives/auth'; // Importar la directiva
import SweetAlert from './plugins/sweetalert'
//import 'sweetalert2/dist/sweetalert2.min.css'

// Configuración de Axios para enviar cookies con cada solicitud
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_INTERNAL; // Ruta Backend Laravel
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Interceptor para el token CSRF
axios.interceptors.request.use(function (config) {
    const token = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN'))
        ?.split('=')[1];

    if (token) {
        config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
    }
    return config;
});

const app = createApp(App);

// Registrar Axios como propiedad global
app.config.globalProperties.$axios = axios;

// Registrar la directiva personalizada para usarse en cualquier componente
app.directive('auth', authDirective);

app.use(router);
app.use(SweetAlert)
app.mount('#app');

